import classNames from 'classnames';
import styles from './video-view.module.scss';
import type { TestMicrophoneReturn, TestSpeakerReturn, VideoPlayer } from '@zoom/videosdk';
import { useRef } from 'react';
import MicrophoneButton from '../../feature/video/components/microphone';
import CameraButton from '../../feature/video/components/camera';

const VideoView = (props: any) => {
  const { isInVBMode, isUseVideoPlayer, videoRef, userName, canvasRef, videoPlayerRef, children, isStartedVideo } =
    props;

  const getInitials = () => {
    const safeUserName = userName || 'User';
    const parts = safeUserName.trim().split(' ');

    if (parts.length === 1) return parts[0][0].toUpperCase();

    const first = parts[0];
    const last = parts[parts.length - 1];

    return (first[0] + last[0]).toUpperCase();
  };

  const stringToColor = (str?: string) => {
    const safeStr = str?.trim() || 'User';
    var hash = 0;
    for (var i = 0; i < safeStr.length; i++) {
      hash = safeStr.charCodeAt(i) + ((hash << 5) - hash);
    }
    var colour = '#';
    for (var i = 0; i < 3; i++) {
      var value = (hash >> (i * 8)) & 0xff;
      colour += ('00' + value.toString(16)).substr(-2);
    }
    return colour;
  };

  return (
    <div className={styles.container}>
      <div className={styles.userTag}>{userName}</div>

      <video className={classNames({ [styles.videoShow]: !isInVBMode })} muted={true} playsInline ref={videoRef} />

      {!isStartedVideo && (
        <div className={styles.avatarContainer}>
          <div className={styles.avatar} style={{ backgroundColor: stringToColor(userName) }}>
            {getInitials()}
          </div>
        </div>
      )}

      {/* {isUseVideoPlayer ? (
        <video-player-container class="video-player-container">
          <video-player
            ref={videoPlayerRef}
            class="video-player"
            className={classNames({ [styles.videoShow]: isInVBMode })}
          />
        </video-player-container>
      ) : (
        <canvas
          className={classNames({ [styles.previewVideoShow]: isInVBMode })}
          width="1280"
          height="720"
          ref={canvasRef}
        />
      )} */}

      <div className={styles.buttonContainer}>{children}</div>
    </div>
  );
};

export default VideoView;
